<div
  [class.notification-details-popup]="isScreenTypeDesktopOrTablet" class="h-full flex items-center justify-center w-full">
  <div *ngIf="!loading"
       class="notification-details-section w-full">
    <div class="notification-heading-section">
      {{notificationDetails.title}}
    </div>
    <div [innerHTML]="notificationDetails.message"

         class="notification-descriptions-section">
    </div>
    <div class="notification-date-section flex" [class.justify-between]="notificationDetails?.data?.link" [class.justify-center]="!notificationDetails?.data?.link">
     <div>
      {{notificationDetails.createdAt| date}}
     </div>
     <div>
      <app-primary-button type="small" (handleClick)="navigateToDetail()">
        {{notificationDetails?.data?.linkCtaName || 'Go To'}}
      </app-primary-button>
     </div>
    </div>
  </div>
  <!--  loading section -->
  <div *ngIf="loading"
       class="flex justify-center items-center loading-section w-full h-full">
    <mat-spinner
      [diameter]="100"
      mode="indeterminate"
      strokeWidth="5"
    />
  </div>
</div>
